import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import styled from 'styled-components';

import Button from '../reusable/button/button.component';
import Spinner from '../reusable/spinner/spinner.component';

import { ConfigurationContext } from '../../contexts/configuration.context.jsx';
import { ToastContext } from '../../contexts/toast.context';

import Client from '../../tools/client';
import { api, tokenName } from '../../config.js';

import {
    RowContainer,
    Image,
    Input
} from '../../styles/component.styles';

const client = new Client();

const Form = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    width: 100%;
    max-width: 320px;
`;

const PasswordWrapper = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    width: 300px;
`;

const PasswordInput = styled(Input)`
    width: 100%;
    padding-right: 36px;
    margin: 0;
`;

const EyeButton = styled.span`
    position: absolute;
    right: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    color: #666;

    &:hover {
        color: #333;
    }
`;

const Login = () => {
    const navigate = useNavigate();
    const [ loading, setLoading ] = useState(false);
    const [ email, setEmail ] = useState('');
    const [ password, setPassword ] = useState('');
    const [ showPassword, setShowPassword ] = useState(false);

    const { configuration, squareLogo } = useContext(ConfigurationContext);
    const { errorToast } = useContext(ToastContext);

    const handleKeyDown = (e) => {
        if(e.key === 'Enter') {
          submitLogin();
        }
      }

    const submitLogin = async () => {
        if(loading) return;
        setLoading(true);
        if(email === '' || password === '') {
            errorToast('Please fill out all fields to login.');
            setLoading(false);
            return
        }

        const data = {
            email,
            password
        }

        const res = await client.login(data);

        if(res.status !== 200) {
            errorToast('There was an error logging in. Please try again.');
            setLoading(false);
            return
        }

        if(res && res.token) {
            localStorage.setItem(tokenName, res.token);
            window.location = '/';
        }
    }

    return (
        <RowContainer onKeyDown={(e) => handleKeyDown(e)} flexDirection={'column'} height={'80vh'} padding={'30px 0'}>
            {loading || !configuration ?
                <Spinner />
            :
                <>
                    {squareLogo &&
                        <Image src={api + squareLogo.path + '.webp'} alt='Logo' />
                    }
                    <Form>
                        <Input type='email' name='email' value={email} onChange={(e) => setEmail(e.target.value)} placeholder='Email' style={{ margin: 0 }} />
                        <PasswordWrapper>
                            <PasswordInput
                                type={showPassword ? 'text' : 'password'}
                                name='password'
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder='Password'
                            />
                            <EyeButton onClick={() => setShowPassword(prev => !prev)}>
                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                            </EyeButton>
                        </PasswordWrapper>
                        <Button onClick={() => submitLogin()} disabled={loading}>Login</Button>
                    </Form>
                </>
            }
        </RowContainer>
    )
}

export default Login;
